/** First strong character: Hebrew/Arabic → rtl, a Latin (or other LTR) letter → ltr. */
const STRONG = /[֐-ࣿיִ-﷿ﹰ-﻿]|[A-Za-zÀ-ɏͰ-ϿЀ-ӿ]/;
const RTL = /[֐-ࣿיִ-﷿ﹰ-﻿]/;

/**
 * The direction a piece of user text reads in (like `dir="auto"`, decided here so the field's padding and icon can
 * follow it too): "1520 Carroll St" stays left-to-right on a Hebrew page. Undefined when there is no letter yet
 * (the field keeps the page's direction).
 */
export const textDir = (text: string): "ltr" | "rtl" | undefined => {
  const m = text.match(STRONG);
  if (!m) return undefined;
  return RTL.test(m[0]) ? "rtl" : "ltr";
};
